import { createAction, props } from '@ngrx/store';

import BetslipActions from './actions';

export class ModalActions {
    private static readonly UPDATE_KEYPAD_STATE = `${BetslipActions.ACTION_SCHEMA}/modal/UPDATE_KEYPAD_STATE`;

    static updateKeypadState = createAction(ModalActions.UPDATE_KEYPAD_STATE, props<{ isOpen: boolean }>());
}
